import { useEffect } from 'react';
import OAutocomplete from '../../../../UI/MuiAutocomplete';
import useHttp from '../../../../../hooks/use-http';
import { urls } from '../api/urls';
import OInput from '../../../../UI/FormControls/OInput';
import { formatDateBody } from '../../../../../../utils/FormatDate';
import TextArea from '../../../../UI/FormControls/TextArea';
import DragAndDrop from '../../../../UI/DragAndDrop';
import CheckBox from '../../../../UI/FormControls/CheckBox';

const Inputs = ({
  formValue,
  setFormValue,
  file,
  setFile,
  handleUkloniFile,
  naplacujeSe,
}) => {
  const { sendRequest: getZaposleni, data: zaposleniData } = useHttp('');
  const {
    sendRequest: getVrstaUslugeZaposleni,
    data: vrstaUslugeZaposleniData,
  } = useHttp('');
  useEffect(() => {
    getZaposleni({ url: urls.GET_ZAPOSLENI_COMBO });
  }, []);

  useEffect(() => {
    if (formValue.idZaposlenog > 0) {
      getVrstaUslugeZaposleni({
        url: urls.GET_VRSTE_ZA_ZAPOSLENOG,
        method: 'POST',
        data: { id: formValue.idDok, idZaposlenog: formValue.idZaposlenog },
      });
    }
  }, [formValue.idZaposlenog]);

  const handleClickZaposleni = (item) => {
    setFormValue((curr) => {
      return {
        ...curr,
        idZaposlenog: item.id,
        zaposleni: item.vrednost,
        idVrstaUsluge: 0,
        nazivUsluge: '',
        jm: '',
        cena: '',
        brutoCenaZaposlenog: '',
      };
    });
  };
  const handleClickVrstaUsluge = (item) => {
    setFormValue((curr) => {
      return {
        ...curr,
        idVrstaUsluge: item.id,
        nazivUsluge: item.vrednost,
        jm: item.jm,
        cena: item.cena,
        brutoCenaZaposlenog: item.cenaKostanja,
      };
    });
  };
  const handleChange = (item) => {
    setFormValue((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };
  const handleFiles = (files) => {
    setFormValue((curr) => {
      return { ...curr, nazivFajla: files[0].name };
    });
    setFile(files);
  };
  const handleChangeCheck = (item) => {
    setFormValue((curr) => {
      return { ...curr, praznik: item.target.checked };
    });
  };
  return (
    <div>
      {' '}
      <OAutocomplete
        data={zaposleniData}
        value={formValue.zaposleni}
        handleClick={handleClickZaposleni}
        label="Zaposleni"
        style={{ width: '100%' }}
        touched={formValue.touchedZaposleni}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedZaposleni: true };
          });
        }}
        errorMessage="Zaposleni je obavezno polje"
      />
      <OAutocomplete
        data={vrstaUslugeZaposleniData}
        value={formValue.nazivUsluge}
        handleClick={handleClickVrstaUsluge}
        label="Vrsta usluge"
        style={{ width: '100%' }}
        touched={formValue.touchedNazivUsluge}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedNazivUsluge: true };
          });
        }}
        errorMessage="Vrsta usluge je obavezno polje"
      />
      <OInput
        label="Jedinica mere"
        name="jm"
        value={formValue.jm}
        handleChange={handleChange}
        style={{ width: '100%' }}
        disabled
      />
      <OInput
        label="Količina"
        name="kolicina"
        value={formValue.kolicina}
        handleChange={handleChange}
        style={{ width: '100%' }}
        type="number"
      />{' '}
      <CheckBox
        style={{ marginTop: '10px' }}
        label="Praznik"
        handleChange={handleChangeCheck}
        checked={formValue.praznik}
        name="praznik"
      />
      <OInput
        label="Bruto cena prema klijentu"
        name="brutoCenaZaposlenog"
        value={formValue.brutoCenaZaposlenog}
        handleChange={handleChange}
        style={{
          width: '100%',
          display: localStorage.getItem('sa') !== 'true' ? 'none' : 'block',
        }}
        type="number"
      />
      {naplacujeSe && (
        <OInput
          label="Cena prema klijentu"
          name="cena"
          value={formValue.cena}
          handleChange={handleChange}
          style={{
            width: '100%',
            display: localStorage.getItem('sa') !== 'true' ? 'none' : 'block',
          }}
        />
      )}
      <OInput
        label="Datum"
        style={{ width: '50%' }}
        handleChange={handleChange}
        type="date"
        value={formatDateBody(formValue.datum)}
        name="datum"
        touched={formValue.touchedDatum}
        setTouched={() => {
          setFormValue((curr) => {
            return { ...curr, touchedDatum: true };
          });
        }}
        errorMessage="Datum je obavezno polje"
      />
      <TextArea
        label="Napomena"
        rows="4"
        name="napomena"
        value={formValue.napomena}
        handleChange={handleChange}
        style={{ width: '100%', height: '100px' }}
      />
      <DragAndDrop
        handleFiles={handleFiles}
        maxFiles={5}
        addedFiles={file}
        handleRemoveFile={handleUkloniFile}
      />
    </div>
  );
};

export default Inputs;
